import { checkIsWebView, getAppVersion } from '@camelot/webview-utils'
import { storeToRefs } from 'pinia'
import { isRunningOnIntHost, isRunningOnLocalHost } from '~/composables/tracking/tracking-scripts'
import { useLocationStore } from '~/stores/location'

export enum SUBSCRIPTION_WEBVIEW_STEPS {
  DATE,
  CATEGORY,
  MILEAGE,
  COVERAGE,
  EXTRAS,
  PAYMENT,
  FINAL,
}

export function navigateToSubscriptionStep(step: SUBSCRIPTION_WEBVIEW_STEPS): string {
  const route = useRoute()
  const { city } = storeToRefs(useLocationStore())
  const BASE = `/webview/${route.params._lang}/${city.value.id}/subscription`

  switch (step) {
    case SUBSCRIPTION_WEBVIEW_STEPS.DATE:
      return `${BASE}/date`
    case SUBSCRIPTION_WEBVIEW_STEPS.CATEGORY:
      return `${BASE}/category`
    case SUBSCRIPTION_WEBVIEW_STEPS.MILEAGE:
      return `${BASE}/mileage`
    case SUBSCRIPTION_WEBVIEW_STEPS.COVERAGE:
      return `${BASE}/coverage`
    case SUBSCRIPTION_WEBVIEW_STEPS.EXTRAS:
      return `${BASE}/extras`
    case SUBSCRIPTION_WEBVIEW_STEPS.PAYMENT:
      return `${BASE}/payment`
    case SUBSCRIPTION_WEBVIEW_STEPS.FINAL:
      return `${BASE}/final`
  }
}

export enum LTCS_WEBVIEW_STEPS {
  ONBOARDING,
  DATE,
  CATEGORY,
  COVERAGE,
  OPTIONS,
  SUMMARY,
  FINAL,
  F2M_RENT,
}

export function navigateToLtcsStep(step: LTCS_WEBVIEW_STEPS): string {
  const route = useRoute()

  const locationStore = useLocationStore()
  const { city } = storeToRefs(locationStore)

  const WEBVIEW_URL = `/webview/${route.params._lang}/${city.value.id}`
  const F2M_RENT_URL = buildF2MRentURL()

  if (step === LTCS_WEBVIEW_STEPS.CATEGORY) {
    return `${WEBVIEW_URL}/category`
  }
  if (step === LTCS_WEBVIEW_STEPS.COVERAGE) {
    return `${WEBVIEW_URL}/coverage`
  }

  if (step === LTCS_WEBVIEW_STEPS.DATE) {
    return `${WEBVIEW_URL}/date`
  }

  if (step === LTCS_WEBVIEW_STEPS.ONBOARDING) {
    return `${WEBVIEW_URL}/service/onboarding`
  }
  if (step === LTCS_WEBVIEW_STEPS.OPTIONS) {
    return `${WEBVIEW_URL}/options`
  }
  if (step === LTCS_WEBVIEW_STEPS.SUMMARY) {
    return `${WEBVIEW_URL}/summary`
  }
  if (step === LTCS_WEBVIEW_STEPS.FINAL) {
    return `${WEBVIEW_URL}/final`
  }
  if (step === LTCS_WEBVIEW_STEPS.F2M_RENT) {
    return F2M_RENT_URL
  }

  return ''
}

function buildF2MRentURL(): string {
  const baseUrl = isRunningOnIntHost() || isRunningOnLocalHost()
    ? 'https://mobileapp.int.free2move.com/rent/'
    : 'https://mobileapp.free2move.com/rent/'

  const utmParams = {
    source: 'app',
    term: 'LoggedInPreBookingWebView',
    campaign: getAppVersion(window),
    medium: 'Web', // Default value if on web which should never happen
  }

  if (checkIsWebView(window, 'webkit')) {
    utmParams.medium = 'AppStore'
  }
  else if (checkIsWebView(window, 'android')) {
    utmParams.medium = 'PlayStore'
  }

  const queryString = Object.entries(utmParams)
    .map(([key, value]) => `utm_${key}=${encodeURIComponent(value)}`)
    .join('&')

  return `${baseUrl}?${queryString}`
}
